export enum FullCalendarViewStyle {
  dayGridMonth = 'dayGridMonth',
  timeGridWeek = 'timeGridWeek',
  timeGridThreeDay = 'timeGridThreeDay',
  timeGridDay = 'timeGridDay',
  listMonth = 'listMonth',
}

export interface BookingEventInit {
  title: string;
  url: string;
  allDay: boolean;
  start: Date;
  end: Date;
  color: string;
  vacancy: number | null;
  waitingList: boolean;
  passwordProtected: boolean;
  classNames: string[];
  meta: {
    resource: { id: string };
    merchant: { id: string };
  };
  params: {
    selectedDate?: string;
    selectedSlot?: string;
  };
  full: boolean | null;
}

export default class BookingEvent {
  public readonly title: string;
  public readonly bookingPageId: string;
  public readonly bookingActionUrl: string;
  public readonly isAllDay: boolean;
  public readonly start: Date;
  public readonly end: Date;
  public readonly color: string;
  public readonly vacancy: number | null;
  public readonly isWaitingListProvided: boolean;
  public readonly isPasswordProtected: boolean;
  public readonly pointer: {
    date?: string;
    slot?: string;
  };
  public readonly classNames: string[];
  public readonly full: boolean | null;

  constructor(init: BookingEventInit) {
    this.title = init.title;
    this.bookingPageId = init.meta.resource.id;
    this.bookingActionUrl = init.url;
    this.isAllDay = init.allDay;
    this.start = init.start;
    this.end = init.end;
    this.color = init.color;
    this.vacancy = init.vacancy;
    this.isWaitingListProvided = init.waitingList;
    this.isPasswordProtected = init.passwordProtected;
    this.pointer = {
      date: init.params.selectedDate,
      slot: init.params.selectedSlot,
    };
    this.classNames = init.classNames;
    this.full = init.full;
  }
}

export class BookingEventList {
  public readonly events: BookingEvent[];

  constructor(inits: BookingEventInit[]) {
    this.events = [];
    inits.map(init => {
      this.events.push(new BookingEvent(init));
    });
  }
}
